import React, { useState, useEffect } from "react";
import vediocallimg from "../asset/vediocallasset.jpeg";
import { FcEndCall, FcVideoCall } from "react-icons/fc";
import { FiPhoneCall } from "react-icons/fi";
import { ChatState } from "../asset/context";
import axios from "axios";
import Lobby from "./Lobby";
function User() {
  const {
    ENDPOINT,
    setStream,
    setLoading,
    calling,
    setCalling,
    callAccepted,
    callRejected,
    setName,
    callUser,
    answerCall,
    call,
    showLobby,
    socket,
    stream,
    online,
    myVideo,
  } = ChatState();
  const [allUsers, setAllusers] = useState([]);
  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((currentStrem) => {
        setStream(currentStrem);
      });
  }, []);
  var url = new URL(window.location.href);

  let parameter = url.searchParams.get("_id").toString();
  useEffect(() => {
    if (showLobby === true) {
      myVideo.current.srcObject = stream;
    }
  }, [showLobby]);
  const getAllUsers = async () => {
    setLoading(true)
    try {
      const { data } = await axios.get(`${ENDPOINT}/users/${parameter}`);
      setAllusers(data);
      setLoading(false)
    } catch (error) {
      alert(error);
      setLoading(false)
    }
  };
  const CallUser = (joinId) => {
    setCalling(true);
    setName(allUsers.fullname);
    callUser(joinId._id);
  };
  useEffect(() => {
    socket.emit("user-join", { emailId: parameter });
  }, []);
  useEffect(() => {
    getAllUsers();
  }, [online]);
  const checkOnlineStatus = (elem) => {
    if (online) {
      const chatMember = [];

      online.map((d, i) => {
        chatMember.push(online[i].userId);
      });
      return chatMember.includes(elem._id);
    }
  };
  return (
    <>
      <div className="Navbar_main_box">
        <div className="navbar_logo">
          <h3>P</h3>
          <h1>2</h1>
          <h3>P</h3>
          <h2>CALL</h2>
        </div>
        <div className="navbar_button">
          <button>Create Room</button>
        </div>
      </div>
      <div className="userTocall_box">
        <div className="activeUsers_box">
          <div className="activeUsers_head">
            <h3>Active Users</h3>
            <span>{online.length - 1}</span>
          </div>
          {allUsers.map((user) => {
            return (
              <div
                className="activeMembers_box"
                key={user._id}
                style={{
                  display: `${checkOnlineStatus(user) ? "flex" : "none"}`,
                }}
              >
                <img src={vediocallimg} alt="foto" />
                <h3>{user.fullname}</h3>
                <FcVideoCall onClick={() => CallUser(user)} />
              </div>
            );
          })}
        </div>
        {call.isReceivingCall && !callAccepted && (
          <div className="answerCall_box">
            <div className="answerCall_img">
              <img src={vediocallimg} alt="foto" />
              <h3>{call.name}</h3>
              <button onClick={callRejected}>
                <FcEndCall />
              </button>
              <button onClick={answerCall}>
                <FiPhoneCall style={{ color: "green" }} />
              </button>
            </div>
          </div>
        )}

        {calling ? (
          <div className="answerCall_box">
            <div className="answerCall_img">
              <img src={vediocallimg} alt="foto" />
              <h3>taqui_imam</h3>
              <h5>Calling....</h5>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <Lobby display={`${showLobby ? "flex" : "none"}`} />
    </>
  );
}

export default User;
